import { useState } from "react";
import { CommonAuthContainer } from "modules/auth/common/CommonAuthContainer";
import { Events, PAGES, usePageTracking } from "modules/tracking";
import SignInView from "../SignInView";

export const SignInContainer = () => {
  const [prefilledEmail, setPrefilledEmail] = useState("");

  usePageTracking(PAGES.SIGNIN);

  return (
    <CommonAuthContainer
      authType={"signin" as const}
      trackEvent={Events.LOGIN_VIEWED}
      setEmail={setPrefilledEmail}
    >
      <SignInView prefilledEmail={prefilledEmail} />
    </CommonAuthContainer>
  );
};
